import SashiDo from 'lib/SashiDo';
import DashboardView from 'dashboard/DashboardView.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import Icon from 'components/Icon/Icon.react';
import React from 'react';
import AppsManager from 'lib/AppsManager';
import Fieldset from 'components/Fieldset/Fieldset.react';
import PreLoader from 'components/PreLoader/PreLoader.react';

import settingsStyles from 'dashboard/Settings/Settings.scss';
import AppBillingDetails from 'dashboard/Billing/AppBillingDetails.react';

import stylesEngine from 'dashboard/Runtime/EngineView.scss';
import stylesBilling from 'dashboard/Billing/Billing.scss';

export default class Overview extends DashboardView {
  constructor(props) {
    super(props);

    this.section = 'Metrics';
    this.subsection = 'Overview';

    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    const newStats = await SashiDo.getAppsBillingStats({ appId: this.context.currentApp.id });
    this.setState({
      appStats: newStats.stats[this.context.currentApp.serviceName],
      loading: false,
    });
  }

  renderContent() {
    const classes = [settingsStyles.settings_page, settingsStyles.default];

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.section} subsection={this.subsection} />
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            <Fieldset legend="Application Details" description="">
              <div className={settingsStyles.settingsBox}>
                {
                  <AppBillingDetails app={this.context.currentApp} stats={this.state.appStats} />
                }
              </div>

              <div className={stylesEngine.legend}>
                <p><span className={stylesEngine.starRed}>*</span> Prices exclude VAT</p>
                <p>
                  <span className={stylesEngine.starBlue}>*</span>
                  SashiDo offers <a href="https://blog.sashido.io/power-up-with-sashidos-brand-new-engine-feature/#discountsandbonuses" target="blank">Sustained use Discounts</a>. These discounts are auto-applied at the end of each billing cycle based on sustained Engine resources usage per app.
                </p>
              </div>
            </Fieldset>

          </div>
        </PreLoader>
      </div>
    );
  }
}
